// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__wxpi3","selected":"Chip_selected__3ZZ6E"};